export const API = process.env.REACT_APP_API;
export const WS_URL = process.env.REACT_APP_WS_URL;
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID
